import styled from "styled-components";

export const Container = styled.div`
  background: #fff;
  width: calc(100vw - 4rem);
  min-height: 85vh;
  padding: 0 2rem 2rem 2rem;
  .navbar {
    width: 100%;
    height: 10vh;
    background: #ff6a00;
    display: flex;
    flex-direction: column;
    border-radius: 0 0 24px 24px;
    margin-bottom: 2rem;
    .navbar-content {
      display: flex;
      flex-direction: column;
      width: calc(100% - 2rem);
      height: 100%;
      justify-content: space-between;
      color: var(--team-secondary-color);
      padding: 0.75rem 1rem;
      .header-links-container {
        overflow: scroll;
        width: 100%;
        &::-webkit-scrollbar {
          display: none;
        }
        ul {
          width: fit-content;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: end;
          padding: 0;
          margin: 0;
          li {
            list-style: none;
            font-weight: 700;
            padding: 0 1rem;
            width: max-content;
            a {
              text-decoration: none;
              position: relative;
              color: var(--team-secondary-color);
              &.active::after {
                content: "";
                position: absolute;
                left: 0;
                bottom: -2px;
                width: 100%;
                height: 4px;
                background-color: var(--team-secondary-color);
                border-radius: 2px;
                z-index: 0;
              }
            }
          }
        }
        select {
          border-radius: 1.5rem;
          padding-left: 0.75rem;
          padding-right: 0.75rem;
          height: 2rem;
          width: fit-content;
          -webkit-appearance: none;
        }
      }
    }
  }
  .boards-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: stretch;
    flex-wrap: wrap;
    gap: 1rem;
    .board-card {
      display: flex;
      flex-direction: column;
      background: #ffffff 0% 0% no-repeat padding-box;
      border: 1px solid lightgray;
      border-radius: 25px;
      width: calc(46% - 2rem);
      padding: 1rem;
      margin: 0;
      height: auto;
      position: relative;
      .options-container {
        position: absolute;
        top: 0;
        right: 1rem;
        font-weight: 700;
        z-index: 9;
        cursor: pointer;
        text-align: right;
        border-radius: 24px;
        .menu {
          font-size: 30px;
          margin: 0;
          color: #000;
        }
        .options {
          margin: 0;
          list-style: none;
          text-align: left;
          flex-direction: column;
          border: 1px solid #ed4242;
          border-radius: 24px;
          padding: 1rem;
          color: #000;
          background: #fff;
          visibility: hidden;
          opacity: 0;
          transition: visibility 200ms, opacity 200ms, display 200ms;
          .delete {
            display: flex;
            justify-content: space-between;
            align-items: center;
            p {
              color: red;
            }
            img {
              width: 20px;
            }
          }
          .edit {
            display: flex;
            justify-content: space-between;
            align-items: center;
            img {
              width: 20px;
            }
          }
          &.active {
            display: flex;
            visibility: visible;
            opacity: 1;
            transition: visibility 200ms, opacity 200ms, display 200ms;
          }
          li {
            font-size: 16px;
            a {
              text-decoration: none;
              color: #000;
            }
          }
        }
      }
      .title {
        flex: 1;
        min-height: 25px;
      }
      .description {
        flex: 1;
        min-height: 40px;
      }
      a {
        width: fit-content;
      }
    }
  }
  .update-suscriptio-container {
    display: flex;
    flex-direction: column;
    text-align: center;
    padding: 2rem;
    .btns-container {
      display: flex;
      flex-direction: column;
      a {
        margin: 0.5rem 0;
      }
    }
  }
  @media only screen and (min-width: 867px) {
    .navbar {
      flex-direction: row;
      .navbar-content {
        width: calc(100%);
        padding: 0.75rem 3rem;
        height: auto;
        justify-content: flex-end;
        .header-links-container {
          overflow: auto;
          ul {
            width: 90%;
            li {
              padding: 0;
            }
          }
        }
      }
    }
    .boards-container
      .board-card
      .options-container
      .options
      .delete
      .trash-can-button {
      width: 20px;
    }
    .boards-container .board-card {
      width: calc(22% - 2rem);
      margin: 0;
    }
    .update-suscriptio-container {
      .btns-container {
        flex-direction: row;
        align-items: center;
        justify-content: center;
        a {
          margin: 0 0.5rem;
        }
      }
    }
  }
`;
